(() => {
  if (window.lnvcCollectionLayout) return;
  window.lnvcCollectionLayout = true;
  const placePopup = (details) => {
    const panel = details.querySelector('.facets__display');
    if (!panel || !details.open) return;
    panel.style.setProperty('--facet-popup-shift', '0px');
    const gutter = parseFloat(getComputedStyle(details.closest('.layout-collection-results, .layout-search')).getPropertyValue('--layout-gutter')) || 24;
    const rect = panel.getBoundingClientRect();
    const right = document.documentElement.clientWidth - gutter;
    const shift = rect.right > right ? right - rect.right : rect.left < gutter ? gutter - rect.left : 0;
    panel.style.setProperty('--facet-popup-shift', `${shift}px`);
  };
  let resizeFrame;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      document.querySelectorAll(':is(.layout-collection-results,.layout-search) .facets__disclosure[open]').forEach(placePopup);
    });
  }, {passive: true});
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    if (!details.closest('.layout-collection-results, .layout-search') || details.closest('.lnvc-shop-results') || !details.open) return;
    if (details.matches('.facets__disclosure')) {
      placePopup(details);
      return;
    }
    if (!details.matches('.mobile-facets__disclosure')) return;
    setTimeout(() => {
      if (!details.open || !details.isConnected) return;
      const panel = details.querySelector('.mobile-facets__inner');
      if (!panel || typeof trapFocus !== 'function' || typeof getFocusableElements !== 'function') return;
      const first = getFocusableElements(panel)[0];
      if (first) (typeof trapDrawerFocus === 'function' ? trapDrawerFocus : trapFocus)(panel, first);
    }, 0);
  }, true);
})();
